import i18n from 'l10n';

const it = {};
it.init = function (selector) {
    const bouncedGroupHandler = function (bouncedGroupCount) {
        $(selector).find("#bounced-title").text(i18n.t("dashboard.bounced", {count: bouncedGroupCount}));
        $(selector).find("#bounced-text").text(bouncedGroupCount);
        $(selector).show();
    };
    const bouncedGroupHrefHandler = function (bouncedGroupId) {
        $('#bouncedGroupDiv').attr('href', "Contacts.htm#Group/" + bouncedGroupId);
        $.getDefaultJSONQ('/CampaignCloud/Group/' + bouncedGroupId + '/count', null, bouncedGroupHandler);
    };
    $.getDefaultJSONQ('/CampaignCloud/Group/bouncedEmailGroupGId', null, bouncedGroupHrefHandler);
};
export default it;